<template>
  <div class="hcl-button-group btn-group btn-group-sm" role="group" :aria-label="props.id">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
interface Props {
  /**
   * Button Group ID
   */
  id?: string
}

const props = withDefaults(defineProps<Props>(), {
  id: 'button-group'
})
</script>
